import ContextEvent from "../../../../../shared/src/ranj/app/core/ContextEvent";
import BaseSplashScreenMediator from "../../../../../shared/src/ranj/equalture/view/BaseSplashScreenMediator";


export default class SplashLoadScreenMediator extends BaseSplashScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, startup, soundManager, config) {
        super(target, dispatcher, languagePack, layoutManager, startup, soundManager, config);
    }

    _handleStartButtonClick() {
        this._buttonStartGame.setEnabled(false);
        this.callDelayed(this._start.bind(this), 30);
    }

}